import { NgModule } from '@angular/core';
import { PanZoomComponent } from './panzoom.component';

@NgModule({
    imports: [PanZoomComponent],
    providers: [],
    exports: [PanZoomComponent]
})

export class NgxPanZoomModule {}
